import React, { useState } from "react"
import { generateUrlByLocale } from "../../services/intl.service"
import { useIntl } from "gatsby-plugin-react-intl"
import { Container, Row, Col } from "react-bootstrap"
import { Link } from "gatsby"
import HTMLReactParser from "html-react-parser"
import { HOTEL_TAXONOMY_VERANDA_RESORTS_ID } from "../../constants"
import PlanYourStay from "../common/planYourStayLink"

const ResortsMenuMobile = ({ resortItems, locale, hotelId, hotelName }) => {
  const isSSR = typeof window === "undefined"
  const intl = useIntl()

  const toggleMenu = (e) => {

    const getAllBtn = document.querySelectorAll(".js-subMenuMob")
    if (getAllBtn) {
      getAllBtn.forEach(item => item.classList.remove('show'));
    }
    const currentElem = e.currentTarget
    currentElem.classList.add("show")

  }
  const closeMenu = (e) => {
    e.currentTarget.previousElementSibling.classList.remove('show')
  }

  let currentPath
  if (!isSSR) {
    currentPath = window.location.pathname
  }

  let menuTitle;

  // Get footer data by locale
  switch (locale) {
    case "fr":
      menuTitle = "Nos Hôtels"
      break
    default:
      menuTitle = "Our Hotels"
  }

  if (typeof hotelId === "undefined") {
    hotelId = HOTEL_TAXONOMY_VERANDA_RESORTS_ID
  }
  
  return (
    <li className="mobResortsLink">
      <button className="resortsMobBtn">
        {menuTitle}
      </button>
      <button
        onClick={toggleMenu}
        aria-label="Sub Menu Mob"
        className="js-subMenuMob"
      ></button>
      <button
        onClick={closeMenu}
        aria-label="Sub Menu Mob"
        className="js-close-subMenuMob"
      ></button>
      <div className="subMenu">
        <Container>
          <Row>
            <Col xs={12}>
              <ul className="second-level">
                {hotelId !== HOTEL_TAXONOMY_VERANDA_RESORTS_ID && (
                  <li>
                    <Link to={intl.locale === "fr" ? "/" : "/en"}>
                      <span> Veranda Resorts</span>
                    </Link>
                  </li>
                )}
                {resortItems.map(
                  resort =>
                    resort.title !== hotelName && (
                      <li key={resort.id}>
                        <Link
                          to={resort.link.url}
                        >
                          <span>
                            {HTMLReactParser(
                                resort.title
                                    .toString()
                                    .replace(/-/g, " ")
                            )}
                          </span>
                        </Link>
                      </li>
                    )
                )}
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    </li>
  )
}

export default ResortsMenuMobile
